export default __webpack_public_path__ + "static/media/localtext.e786ad51.csv";